var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriorityHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.6464L6.87654 19.5969C6.60905 19.8752 6.28498 20.0094 5.90432 19.9995C5.52366 19.9895 5.1893 19.8454 4.90123 19.5671C4.63374 19.3086 4.5 18.9955 4.5 18.6277C4.5 18.2599 4.63374 17.9467 4.90123 17.6883L10.0247 12.7378C10.5802 12.2209 11.2387 11.9625 12 11.9625C12.7613 11.9625 13.4198 12.2209 13.9753 12.7378L19.0988 17.6883C19.3663 17.9467 19.5 18.2648 19.5 18.6426C19.5 19.0203 19.3663 19.3384 19.0988 19.5969C18.8107 19.8553 18.4763 19.9846 18.0957 19.9846C17.715 19.9846 17.3807 19.8553 17.0926 19.5969L12 14.6464ZM12 6.65416L6.87654 11.6344C6.60905 11.8929 6.28498 12.0221 5.90432 12.0221C5.52366 12.0221 5.1893 11.8929 4.90123 11.6344C4.63374 11.376 4.5 11.0628 4.5 10.695C4.5 10.3272 4.63374 10.0042 4.90123 9.72582L10.0247 4.80519C10.5802 4.2684 11.2387 4 12 4C12.7613 4 13.4198 4.2684 13.9753 4.80519L19.0988 9.72582C19.3663 10.0042 19.5 10.3272 19.5 10.695C19.5 11.0628 19.3663 11.376 19.0988 11.6344C18.8107 11.9128 18.4763 12.0519 18.0957 12.0519C17.715 12.0519 17.3909 11.9128 17.1235 11.6344L12 6.65416Z",
    fill: "#D30813"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityHigh);
export default __webpack_public_path__ + "static/media/priority-high.1984104d03db0fe8e60b44d3d89e8161.svg";
export { ForwardRef as ReactComponent };